module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (1 == 2) ? _c('div', [_c('div', {
    staticClass: "text-xs-center grey--text text--darken-1 my-4",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.irParaOTopo($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text-xs-center grey--text text--darken-1 cursor_pointer"
  }, [_vm._v("arrow_upwards")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "cursor_pointer"
  }, [_vm._v("Ir para o topo")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4a76b96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/IrParaOTopo.vue
// module id = 1044
// module chunks = 1